import { Link } from "react-router-dom";
import SiteLogo from "@/components/feature/SiteLogo";
import SectionHeading from "@/components/feature/SectionHeading";
import { getCategoryById, getNewSites } from "@/utils/site";

export default function NewSites() {
  const newSites = getNewSites();

  return (
    <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        icon="ri-time-line"
        title="最新收录网站推荐"
        subtitle="近期新增或更新的网站入口，帮你发现更多资源"
        action={{ label: "查看全部", to: "/category/tools" }}
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {newSites.map((site) => {
          const category = getCategoryById(site.categoryId);
          return (
            <Link
              key={site.id}
              to={`/detail/${site.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 hover:bg-accent-50/40"
            >
              <SiteLogo site={site} size={52} />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="truncate text-base font-semibold text-foreground-950">{site.name}</h3>
                  <span className="shrink-0 rounded-full bg-accent-500 px-2 py-0.5 text-[10px] font-medium text-background-50">
                    新收录
                  </span>
                </div>
                <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-foreground-600">{site.desc}</p>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-folder-line"></i>
                    {category?.name}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {site.updatedAt}
                  </span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line mt-1 text-xl text-foreground-400 transition-colors group-hover:text-accent-500"></i>
            </Link>
          );
        })}
      </div>
    </section>
  );
}